/**
 * 操作权限处理
 * Copyright (c) 2019 ruoyi
 */

import store from '@/store';
import XEUtils from 'xe-utils/methods/xe-utils';

export default {
  inserted(el, binding) {
    let { value } = binding;
    if (typeof value == 'string') value = value.split(',');
    const all_permission = '*:*:*';
    let permissions = [];
    if (store.state.authCode) {
      permissions = XEUtils.clone(store.state.authCode.authCode, true);
    }
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermissions = permissions.some((permission) => {
        return all_permission === permission || permissionFlag.includes(permission);
      });

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(el.textContent + `按钮没有设置权限`);
    }
  },
};
